import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaProjectDiagram, FaPlusCircle, FaChevronDown } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProjects } from '../../../Redux/Projects/projectSlice';
import '../../../Stylesheets/Dashboard/Sidebar.css';
import Logo from '../../../assets/images/logo.png';
import { motion, AnimatePresence } from 'framer-motion';

// Add after imports
const subProjectVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.07 },
  }),
  exit: { opacity: 0, x: -20 },
};

const Sidebar = ({ isOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showSubprojects, setShowSubprojects] = useState(false);
  const { list: projects, status } = useSelector((state) => state.projects);

  useEffect(() => {
    if (status === 'idle') dispatch(fetchProjects());
  }, [dispatch, status]);

  const isActive = (path) => location.pathname === path;

  const handleProjectClick = () => {
    navigate('/dashboard/projects');
  };

  return (
    <aside className={`dashboard-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-logo">
        <img src={Logo} alt="Site360 Logo" />
      </div>

      <nav className="sidebar-nav">
        <Link to="/dashboard" className={`sidebar-link ${isActive('/dashboard') ? 'active' : ''}`}>
          <FaHome /> Overview
        </Link>

        <div className="sidebar-link project-toggle">
          <div
            onClick={handleProjectClick}
            style={{ display: 'flex', alignItems: 'center', flex: 1, cursor: 'pointer' }}
          >
            <FaProjectDiagram />
            <span style={{ marginLeft: 10 }}>Projects</span>
          </div>

          {projects.length > 0 && (
            <FaChevronDown
              className={`chevron-icon ${showSubprojects ? 'rotated' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                setShowSubprojects((prev) => !prev);
              }}
            />
          )}
        </div>

        <AnimatePresence initial={false}>
          {showSubprojects &&
            projects.map((proj, i) => (
              <motion.div
                key={proj._id}
                initial="hidden"
                animate="visible"
                exit="exit"
                custom={i}
                variants={subProjectVariants}
              >
                <Link
                  to={`/dashboard/project/${proj._id}`}
                  className="sidebar-link sub-project-link"
                >
                  {proj.name}
                </Link>
              </motion.div>
            ))}
        </AnimatePresence>


        <Link
          to="/dashboard/create"
          className={`sidebar-link ${isActive('/dashboard/create') ? 'active' : ''}`}
        >
          <FaPlusCircle /> Create Project
        </Link>
      </nav>

      <div className="sidebar-footer">
        <Link to='/dashboard/How-to-use' className='no-link-style'><p>How to Use?</p></Link>
        <Link to='/dashboard/Whats-new' className='no-link-style'><p>What’s New?</p></Link>
        <Link to='/dashboard/Contact-us' className='no-link-style'><p>Contact Us</p></Link>
      </div>
    </aside>
  );
};

export default Sidebar;
